import { html, ref, repeat } from '@microsoft/fast-element';
import { EditUserModal } from './edit-user-modal';

export const EditUserModalTemplate = html<EditUserModal>`
  <right-side-modal
    position="right"
    show-close-icon
    show="${(x) => x.show}"
    @modalClosing="${(x) => x.onCloseCallback()}"
    width="${(x) => x.width}"
    header="${(x) => x.title}"
    ${ref('modal')}
  >
    <div class="edit-user-modal-content">
      <div class="form-control required">
        <zero-text-field
          ${ref('usernameTxt')}
          placeholder="Username"
          required
          appearance="outline"
          autocapitalize="off"
          @change="${(x) => x.checkFormCompletionStatus()}"
          oninput="this.value = this.value.toLowerCase()"
          value=${(x) => x.data?.USER_NAME}
        >
          Username
        </zero-text-field>
      </div>
      <div class="form-control">
        <zero-text-field
          ${ref('emailTxt')}
          placeholder="Email"
          appearance="outline"
          autocapitalize="off"
          oninput="this.value = this.value.toLowerCase()"
          value=${(x) => x.data?.EMAIL_ADDRESS}
        >
          Email
        </zero-text-field>
      </div>
      <div class="form-control">
        <zero-text-field
          ${ref('firstNameTxt')}
          placeholder="First Name"
          appearance="outline"
          autocapitalize="off"
          value=${(x) => x.data?.FIRST_NAME}
        >
          First Name
        </zero-text-field>
      </div>
      <div class="form-control">
        <zero-text-field
          ${ref('lastNameTxt')}
          placeholder="Last Name"
          appearance="outline"
          autocapitalize="off"
          value=${(x) => x.data?.LAST_NAME}
        >
          Last Name
        </zero-text-field>
      </div>
      <div style="display: ${(x) => (x.editing ? 'none' : '')}" class="form-control required">
        <zero-text-field
          ${ref('passwordTxt')}
          placeholder="One Time Password"
          appearance="outline"
          required
          autocapitalize="off"
          @change="${(x) => x.checkFormCompletionStatus()}"
          value=${(x) => x.data?.ONE_TIME_PASSWORD}
        >
          One Time Password
        </zero-text-field>
      </div>
      <div style="display: ${(x) => (x.isAdmin ? '' : 'none')}" class="form-control">
        <zero-checkbox
          @click="${(x) => (x.isCascadeAdmin = !x.isCascadeAdmin)}"
          ?current-checked=${(x) => x?.isCascadeAdmin}
          ?disabled="${(x) => x.editing}"
        >
          Is Cascade Admin
        </zero-checkbox>
      </div>
      <div
        style="display: ${(x) => (x.isCascadeAdmin ? 'none' : '')}"
        class="form-control required"
      >
        <label class="label">Company</label>
        <zero-select
          position="below"
          class="input-control"
          ${ref('companyElement')}
          @change="${(x) => x.filterProfilesByCompanyRole()}"
        >
          <zero-option value="">Select Company</zero-option>
          ${repeat(
            (x) => x.companyList,
            html`
              <zero-option value="${(x) => x.CASCADE_COMPANY_ID}">${(x) => x.NAME}</zero-option>
            `,
          )}
        </zero-select>
      </div>
      <div class="form-control required">
        <label class="label">User Profiles</label>
        <zero-multiselect
          ${ref('profileMulti')}
          :all="false"
          ?disabled="${(x) => !x.companyElement.value}"
          @selectionChange=${(x) => x.filterProfileOptions()}
        ></zero-multiselect>
      </div>
    </div>

    <zero-button
      slot="buttons"
      appearance="primary"
      @click="${(x) => x.submit()}"
      ?disabled="${(x) => !x.isFormValid}"
    >
      Submit
    </zero-button>
  </right-side-modal>
`;
